awardCalculation.classy.controller({
    name: 'AddedAllowancesController',
    inject: ['$scope', 'ApplicationService', 'AddedAllowanceModelFactory', '$timeout', 'TabsService', 
        'SliderCudFactory', 'CalculationService'],
    init: function()
    {
        this.$.TabsService = this.TabsService;
        this.$.familyIndex = this.ApplicationService.getFamilyNo();
        this.id = this.ApplicationService.getFamilyID();
        this.model = new this.AddedAllowanceModelFactory(this.id);
        this.$.itemOpen = false;
        this.$.isValid = false;
        var sum = 0;
        for (var i = 0; i < this.ApplicationService.getFamilyData().addedAllowance.length; i++) {
            sum += Number(this.ApplicationService.getFamilyData().addedAllowance[i].amount);
        }
        // if (sum==0 && this.ApplicationService.getFamilyData().edit_sums.Exp_Added>0) {
        //     var index = this.model.new(this.$.familyIndex);
        //     this.model.data[index].text = 'Miscellaneous';
        //     this.model.data[index].amount = this.ApplicationService.getFamilyData().edit_sums.Exp_Added;
        //     this.ApplicationService.getFamilyData().addedAllowance.push(this.model.data[index]);
        // }
        
    },
    afterSave: function()
    {
        this.ApplicationService.getFamilyData().addedAllowance[this.$.index] = this.$.item;
        this.CalculationService.reCalc();
    },
    setItemOpen: function(index)
    {
        if(index != -1)
        {
            this.$.index = index;
            this.$.item = this.model.data[index];
            this.$.itemOpen = true;
        }
        else
            this.$.itemOpen = false;
    },
    add: function()
    {
        var index = this.model.new(this.$.familyIndex);
        this.setItemOpen(index);
    },
    startSaveProcess: function(scope, instance, form)
    {   
        var parent = this;
        if (form.$valid)
        {
            instance.options.factor = .5;
            if ((typeof this.$.item[this.model.primaryKey] !== 'undefined')) {
                this.model.put(this.id, this.$.item, instance)
            }
            else {
                this.model.post(this.id, this.$.item, instance)
            }
        }
        else
            instance.stop(-1);
    },
    successSave: function (scope, instance, callback)
    {
        
        var parent = this;
        if(instance.options.config.method == "POST")
        {
            this.$.item.recordID = instance.options.data.id;
        }
        this.$timeout(function()
        {
            parent.setItemOpen(-1);
        }, 1000);
        if (typeof callback != 'undefined')
            callback();
    },
    startDeleteProcess: function(scope, instance)
    {
        instance.options.factor  = .5;
        return this.model.purge(this.id, this.$.item, instance);
    },
    successDelete: function(scope, instance)
    {
        this.model.data.splice(this.$.index, 1)
        this.model.updateData();
        var parent = this;
        this.$timeout(function()
        {
            parent.setItemOpen(-1);
        }, 1000);
    }
});
